import React from 'react';
import { Edit, DisabledInput } from 'react-admin';
import SubtemaForm from '../SubtemaForm';

function SubtemaEdit(props) {
  return (
    <Edit undoable={false} {...props}>
      <SubtemaForm redirect="list">
        <DisabledInput label="Id" source="id" />
      </SubtemaForm>
    </Edit>
  );
}

export default SubtemaEdit;
